import React from "react";
import { IconButton } from "@mui/material";
import styled from "styled-components/macro";
import { TextareaAutosize } from "@mui/material";
import { t } from "i18next";
import { MAX_MESSAGE_LENGTH } from "./FullChat";

export const ICON_SIZE = "50px";

export const InputIconButton = styled(IconButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${ICON_SIZE};
  height: ${ICON_SIZE};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.duo.palette.blueMain} !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: none;
  transition: transform 0.1s;
  outline: none;
  margin: -4px 3px 0 0;
  -webkit-tap-highlight-color: transparent;
  svg {
    font-size: 22px;
  }
  &:hover,
  &:focus,
  &:active,
  &:focus-visible {
    background-color: ${({ theme }) => theme.duo.palette.blueMain} !important;
  }
  &.Mui-disabled {
    background-color: ${({ theme }) => theme.duo.palette.blueMain} !important;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const STextareaAutosize = styled(TextareaAutosize)`
  border-radius: ${(p) => p.theme.duo.borderRadius.normal};
  font-size: ${(p) => p.theme.duo.fontSize.normal};
  padding: 10px 12px;
  padding-right: 45px;
  border-color: ${(p) => p.theme.duo.color.grey};
  width: 100%;
  text-align: left;

  &::-webkit-resizer {
    display: none;
  }
  &::placeholder {
    color: ${(p) => p.theme.duo.color.textGrey};
  }
`;

export const InputTextarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<typeof TextareaAutosize>>(
  (props, ref) => {
    return (
      <STextareaAutosize
        ref={ref}
        maxRows={10}
        placeholder={t("Type or tap mic")}
        maxLength={MAX_MESSAGE_LENGTH}
        dir="auto"
        {...props}
      />
    );
  }
);
